import { formTransformer } from 'utils';

/**
 * The API nests a club's relations as objects ({id, title, …}); the form's
 * selects are keyed by id. Without this the edit dialog would hand an object
 * to a <TextField select> and render a blank field.
 */
export const clubToFormTransformer = club => {
    if (! club) {
        return null;
    }

    return {...formTransformer(club, ['location', 'association', 'parentClub'])};
}
